import { Grid } from "@mui/material";
import { Box, styled } from "@mui/system";
import colors from "../../styles/colors/colors";

export const ErrorBox = styled(Box)(() => ({
  justifyContent: "center",
}));

export const GridLayout = styled(Grid)(() => ({
  display: "flex",
  justifyContent: "center",
  height: "100vh",
}));
export const GridItem = styled(Grid)(() => ({
  minHeight: "18rem",
  minWidth: "50%",
  backgroundColor: colors.primary.light,
  borderRadius: "0.9rem",
  padding: "2rem",
  alignSelf: "center",
  boxShadow: `0.1rem 0.1rem 0.1rem 0.1rem ${colors.dropShadow[1]}`,
}));

export const GenderInputUI = () => ({
  width: "100%",
});

export const OddEvenDropdownStyle = (index: number) => ({
  backgroundColor: index % 2 === 0 ? colors.white[1] : colors.borders[5] , 
  "&:hover": {
    backgroundColor: colors.borders[2],
  },
  textWrap: "auto",
});

export const EmailTextStyle = ({
  cursor: "pointer",
  textDecoration: "none", 
  fontWeight: "bold",     
  pl: "0.5rem", 
  color: colors.primary.main
});

export const InvalidRequestLayoutSx = {
  px: { xs: 2, md: 3 },
  pt: 3,
  alignItems: "center",
};

export const InvalidRequestContentGridSx = {
  alignSelf: "center",
};

export const InvalidRequestCardSx = {
  minWidth: "100%",
  minHeight: "12.5rem",
  borderRadius: "0.35rem",
};

export const InvalidRequestErrorBoxSx = {
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  minHeight: "100%",
};

export const InvalidRequestTitleSx = {
  width: { xs: "15rem", md: "20rem" },
  textAlign: "left",
  whiteSpace: "nowrap",
};

export const InvalidRequestSubtitleSx = {
  width: { xs: "15rem", md: "20rem" },
  textAlign: "left",
};